module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-card', {
    attrs: {
      "no-body": ""
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function() {
        return [_c('b-row', [_c('b-col', [_c('h4', [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('b-col', {
          staticClass: "text-right"
        }, [_c('b-button', {
          class: !_vm.localVisible ? 'collapsed' : null,
          attrs: {
            "variant": "link",
            "aria-controls": "contentPanel",
            "aria-expanded": _vm.localVisible ? 'true' : 'false'
          },
          on: {
            "click": function($event) {
              _vm.localVisible = !_vm.localVisible
            }
          }
        }, [_c('icon', {
          attrs: {
            "name": _vm.localVisible ? 'chevron-down' : 'chevron-left'
          }
        })], 1)], 1)], 1)]
      },
      proxy: true
    }])
  }, [_vm._v(" "), _c('b-card-body', {
    staticClass: "p-0"
  }, [_c('b-collapse', {
    attrs: {
      "id": "contentPanel"
    },
    model: {
      value: (_vm.localVisible),
      callback: function($$v) {
        _vm.localVisible = $$v
      },
      expression: "localVisible"
    }
  }, [_vm._t("default")], 2)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a57f7656","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CollapsibleCard.vue
// module id = 2147
// module chunks = 1